import type { Track, TimeRange } from '../types/scenario';
import type { AisPosition } from '../types/generated-data';
import type { ValidationResult } from '../types/generator';
import { AisGenerator } from './ais-generator';

const generator = new AisGenerator();

/**
 * Generate positions for a track. All data types (ais, radar, drone, das)
 * share the same interpolation logic — the data_type is just a label on the track.
 */
export function generateTrackPositions(
  track: Track,
  timeRange?: TimeRange,
): AisPosition[] {
  return generator.generate(track, timeRange);
}

/**
 * Validate a track before generation.
 */
export function validateTrack(
  track: Track,
  timeRange?: TimeRange,
): ValidationResult {
  return generator.validate(track, timeRange);
}
